import './App.css';

import BiographyContent from './BiographyContent';
import ContentLayout from './ContentLayout';

function About() {
  return (
    <ContentLayout
      title="Biography"
      intro="Best-selling children's non-fiction author from Cheshire, north-west England."
      heroImage="/banners/johnbiog1.jpg"
    >
      <BiographyContent />
    </ContentLayout>
  );
}

export default About;
